import React, { useEffect, useState } from "react";
import "./css/levels.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import policyEn from "locales/policies/policy.en.json";
import policyFr from "locales/policies/policy.fr.json";

const languageMap = new Map([
  ["0", policyEn],
  ["1", policyFr]
]);

const Policy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [policy, setPolicy] = useState({});

  useEffect(() => {
    const languageId = localStorage.getItem("selectedLanguage");
    const mappedPolicy = languageMap.get(languageId);

    if (mappedPolicy) {
      setPolicy(mappedPolicy);
    } else {
      setPolicy(languageMap.get("1"));
    }
  }, []);

  return (
    <div className="home">
      <div className="main">
        <div className="container-fluid box-wrapper difficult">
          <div className="page-header pb-5">
            <div className="box-wrapper mx-auto text-center position-relative header-container">
              <button type="button" className="icon-button" onClick={() => navigate(-1)}>
                <img src="/image/back.png" className="arrow" alt="back" />
              </button>
              <span className="levels-title">{t("12")}</span>
            </div>
          </div>
          <div className="home-profile">
            <h4 className="text-center">{policy.heading}</h4>
            <div className="my-4">
              {policy?.subheadings?.map((section, i) => (
                <div key={section.id + i} className="mb-3">
                  <h6>
                    {section.id}. {section.title}
                  </h6>
                  {section.subheadings.map((subsection, j) => (
                    <p key={subsection.id + j} className="policy-description mb-0">
                      <span>{subsection.id ? `${subsection.id}. ` : ""}</span>
                      <span>{subsection.content}</span>
                    </p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
